import React from 'react';
import { motion } from 'framer-motion';
import { ControllerIcon } from './ControllerIcon';
import { StarRating } from './StarRating';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden" data-id="element-57">
      {/* Background decorative elements */}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/4 opacity-5 pointer-events-none" data-id="element-58">
        <ControllerIcon variant="full" className="w-[800px] h-[800px] text-gameu-text" data-id="element-59" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10 w-full" data-id="element-60">
        <div className="max-w-3xl" data-id="element-61">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-62">
            <div className="flex items-center gap-4 mb-8" data-id="element-63">
              <StarRating rating={5} starSize={24} data-id="element-64" />
              <span className="text-gameu-accent text-sm font-medium tracking-widest uppercase" data-id="element-65">
                The SEO Agency for Gaming Sites
              </span>
            </div>

            <h1 className="font-serif text-6xl md:text-8xl leading-[1.1] mb-8 text-gameu-text" data-id="element-66">
              Your Gaming Reviews <br data-id="element-67" />
              <span className="text-gameu-muted italic" data-id="element-68">Deserve Revenue.</span>
            </h1>

            <p className="text-xl text-gameu-muted mb-12 max-w-2xl leading-relaxed" data-id="element-69">
              We turn gaming review and comparison sites into high-ranking,
              high-earning properties. Stop leaving traffic on the table and
              start monetizing your editorial authority.
            </p>

            <div className="flex flex-wrap items-center gap-6" data-id="element-70">
              <a href="#pricing" className="bg-gameu-accent text-gameu-base px-8 py-4 font-medium hover:bg-white transition-colors flex items-center gap-2" data-id="element-71">
                View Investment Tiers
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-72">
                  <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" data-id="element-73" />
                </svg>
              </a>
              <a href="#results" className="text-gameu-text hover:text-gameu-accent transition-colors font-medium" data-id="element-74">
                See our rankings →
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}